"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ButtonReFresh_1 = require("../buttons/ButtonReFresh");
var ButtonCreate_1 = require("../buttons/ButtonCreate");
var ButtonGoBack_1 = require("../buttons/ButtonGoBack");
var ToolBarButtonsOnly = /** @class */ (function (_super) {
    __extends(ToolBarButtonsOnly, _super);
    function ToolBarButtonsOnly(props) {
        return _super.call(this, props) || this;
    }
    ToolBarButtonsOnly.prototype.buttonReFreshClick = function () {
        if (this.props.onClick) {
            this.props.onClick("refresh");
        }
    };
    ToolBarButtonsOnly.prototype.buttonBackClick = function () {
        if (this.props.onClick) {
            this.props.onClick("back");
        }
    };
    ToolBarButtonsOnly.prototype.buttonCreateClick = function () {
        if (this.props.onClick) {
            this.props.onClick("create");
        }
    };
    ToolBarButtonsOnly.prototype.getBackButton = function () {
        if (this.props.hint.back) {
            return React.createElement(ButtonGoBack_1.default, { val: this.props.hint.back, hint: this.props.hint.back, onClick: this.buttonBackClick.bind(this) });
        }
        else {
            return null;
        }
    };
    ToolBarButtonsOnly.prototype.getCreateButton = function () {
        if (this.props.hint.create) {
            if (this.props.menu) {
                if (this.props.menu.create) {
                    console.log("drop down create!");
                    return React.createElement(ButtonCreate_1.default, { hint: this.props.hint.create, onClick: this.buttonCreateClick.bind(this), menu: this.props.menu.create });
                }
            }
            return React.createElement(ButtonCreate_1.default, { hint: this.props.hint.create, onClick: this.buttonCreateClick.bind(this) });
        }
        else {
            return null;
        }
    };
    ToolBarButtonsOnly.prototype.getRefreshButton = function () {
        if (this.props.hint.refresh) {
            return React.createElement(ButtonReFresh_1.default, { hint: this.props.hint.refresh, onClick: this.buttonReFreshClick.bind(this) });
        }
        else {
            return null;
        }
    };
    ToolBarButtonsOnly.prototype.getChildren = function (location) {
        if (location === "BEFORE") {
            if (this.props.firstChildren) {
                return this.props.children;
            }
        }
        if (location === "AFTER") {
            if (!this.props.firstChildren) {
                return this.props.children;
            }
        }
        return null;
    };
    ToolBarButtonsOnly.prototype.render = function () {
        return (React.createElement("div", { style: { display: "flex", width: "100%", flexWrap: "nowrap", justifyContent: "flex-start", alignItems: "center" } },
            this.getChildren("BEFORE"),
            this.getBackButton(),
            this.getCreateButton(),
            this.getRefreshButton(),
            this.getChildren("AFTER")));
    };
    return ToolBarButtonsOnly;
}(React.Component));
exports.default = ToolBarButtonsOnly;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/toolbars/ToolBarButtonsOnly.tsx
// module id = 8
// module chunks = 0